import { render } from "./SaveWorkShift.vue?vue&type=template&id=d991ae2e&scoped=true"
import script from "./SaveWorkShift.vue?vue&type=script&lang=js"
export * from "./SaveWorkShift.vue?vue&type=script&lang=js"

import "./work-shift.scss?vue&type=style&index=0&id=d991ae2e&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d991ae2e"]])

export default __exports__